import { render, staticRenderFns } from "./modeloAdd.vue?vue&type=template&id=30c62aa9"
import script from "./modeloAdd.vue?vue&type=script&lang=js"
export * from "./modeloAdd.vue?vue&type=script&lang=js"
import style0 from "./modeloAdd.vue?vue&type=style&index=0&id=30c62aa9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports